import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-mist px-4 py-14 sm:py-20" aria-labelledby="ba-title" data-id="element-94" data-mp="26k9xmja7pdch">
      <div className="mx-auto max-w-5xl" data-id="element-95" data-mp="22mlzl7d834gd">
        <SectionHeading id="ba-title" data-id="element-96" data-mp="2zarwt97teukm">
          From scattered observations to <span className="text-accent-600" data-id="element-97" data-mp="2z8xkgjam0as5">structured clinical documentation</span>
        </SectionHeading>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-6" data-id="element-98" data-mp="2ua45emfocbpv">
          <div className="flex flex-col overflow-hidden rounded-2xl bg-white ring-2 ring-alert/30" data-id="element-99" data-mp="2q8sgyk8jdwj9">
            <h3 className="bg-alert px-3 py-3 text-center font-display text-lg font-black uppercase text-white sm:text-2xl" data-id="element-100" data-mp="2laqurqftdh3k">
              Before
            </h3>
            <ul className="flex flex-1 flex-col gap-3 p-3 sm:gap-4 sm:p-6" data-id="element-101" data-mp="19vu6iirgevx9">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-ink/80 sm:text-base" data-id="element-102" data-mp="176nro7a11tca">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert sm:h-5 sm:w-5" aria-hidden="true" data-id="element-103" data-mp="1c3nwyfz1ys2c" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col overflow-hidden rounded-2xl bg-navy-900 ring-2 ring-accent-500" data-id="element-104" data-mp="131xvsifdcerd">
            <h3 className="bg-accent-500 px-3 py-3 text-center font-display text-lg font-black uppercase text-navy-950 sm:text-2xl" data-id="element-105" data-mp="ocrxqxs9oul2">
              After
            </h3>
            <ul className="flex flex-1 flex-col gap-3 p-3 sm:gap-4 sm:p-6" data-id="element-106" data-mp="ffhm3bbjf3fm">
              {afterItems.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-medium leading-snug text-white sm:text-base" data-id="element-107" data-mp="jg1k0h3xqb2t">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent-400 sm:h-5 sm:w-5" aria-hidden="true" data-id="element-108" data-mp="af3nskzqn7us" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-ink/75 sm:text-lg" data-id="element-109" data-mp="27d0xhh3k8y1i">
          The transformation isn't about replacing clinical expertise. It's about making your assessment process{' '}
          <strong className="text-navy-900" data-id="element-110" data-mp="1ye5qi2sozjx5">more organized, consistent, and traceable.</strong>
        </p>

        <SectionCTA label="Take me to the After side" data-id="element-111" data-mp="2v2lj67r3m9eh" />
      </div>
    </section>;
}